import { decamelizeKeys } from 'humps';

import { apiClient } from '../apiClient';

export const PATHS = {
  QUESTIONS: '/api/v4/pre-diabetes/questions/',
  RESPONSES: '/api/v4/pre-diabetes/responses/',
} as const;

export type PreDiabetesChoice = {
  order: number;
  text: string;
  surveyChoiceUrn: string;
};

export type PreDiabetesQuestion = {
  key: string;
  order: number;
  title: string;
  text: string;
  additionalInfo: string;
  choices: PreDiabetesChoice[];
};

export type PreDiabetesResponse = {
  questionKey: string;
  surveyChoiceUrn: string;
};

export async function fetchPreDiabetesQuestions(
  signal?: AbortSignal
): Promise<PreDiabetesQuestion[]> {
  const res = await apiClient.get<{ items?: PreDiabetesQuestion[] }>(PATHS.QUESTIONS, { signal });
  return res.data?.items ?? [];
}

// Posting responses records the user's `prediabetes-risk` metric point on the
// backend (the response carries the score), which is what lets onboarding
// resume past pre-diabetes later. Mirrors Sparta's postPreDiabetesResponses.
export async function submitPreDiabetesResponses(
  userUrn: string,
  responses: PreDiabetesResponse[]
): Promise<void> {
  await apiClient.post(PATHS.RESPONSES, decamelizeKeys({ userUrn, responses }));
}
